import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import 'firebase/compat/storage'
import 'firebase/compat/functions'

// @ts-ignore
import { firebaseConfig } from 'config'

// Initialize Firebase instance
firebase.initializeApp(firebaseConfig)

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  console.log('NOTE: useFunctionsEmulator > http://localhost:5001 ENABLED')
  firebase.functions().useFunctionsEmulator('http://localhost:5001')
  firebase.auth().useEmulator('http://localhost:9099/')
  firebase.database().useEmulator('localhost', 9000)
  firebase.storage().useEmulator("localhost", 9002)

}

export default firebase